<template>
  <h1>商品カタログ</h1>
</template>
